<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết thiết bị cho mượn và đổi trả</h1>
      <div class="float-right d-flex">
        <div>
          <button
            v-if="canAction.recall"
            class="f12 font-medium btn btn-outline-primary mr-2"
            @click="handleReqReceipt"
          >
            Yêu cầu thu hồi
          </button>
          <button
            v-if="canAction.extend"
            class="f12 font-medium btn btn-outline-warning mr-2"
            @click="handleExtend"
          >
            Gia hạn thêm
          </button>
        </div>
        <button
          class="f12 font-medium btn btn-outline-secondary"
          @click="$router.push('/management-lend-device-v1')"
        >
          Quay lại
        </button>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-12">
          <div class="form-row gap-4">
            <div class="col-lg-6 col-md-12">
              <CardDetail title="Thông tin chung" :fields="generalFields">
                <template #inforMC>
                  <p class="form-control-plaintext f12 mb-0">
                    {{ dataOverviewInfor.merchantName }}
                  </p>
                  <p class="form-control-plaintext f12 mb-0">
                    {{ dataOverviewInfor.merchantEmail }}
                  </p>
                </template>
                <template #status="data">
                  <b-badge :variant="mapVariantStatusIDLend[data.item.value]">
                    {{ mapTextStatusIDLend[data.item.value] }}
                  </b-badge>
                </template>
                <template #statusInvoiceExported="data">
                  <b-badge :variant="data.value ? 'success' : 'primary'">
                    {{ data.value ? 'Đã xuất hóa đơn' : 'Chưa xuất hóa đơn' }}
                  </b-badge>
                </template>
                <template #lendingStartTime="data">
                  {{ data.value | formatDate }}
                </template>
              </CardDetail>
            </div>
            <div class="col-lg-6 col-md-12">
              <CardDetail title="Thông tin phiếu thu" :fields="receiptInfor">
                <template #status="data">
                  <b-badge :variant="mapVariantReceiptStatus[data.value] ?? 'primary'">
                    {{ mapTextReceiptStatus[data.value] ?? '' }}
                  </b-badge>
                </template>
                <template #receiptTime="data">
                  {{ data.value | formatDate }}
                </template>
              </CardDetail>
              <div class="form-detail">
                <h1>Thông tin phiếu hoàn tiền / Thu thêm</h1>
                <div v-if="dataOverviewInfor.refundCode" class="card-body">
                  <p>
                    <span class="text-muted">Phiếu hoàn: </span>
                    <span>{{ dataOverviewInfor.refundCode }}</span>
                  </p>
                  <p>
                    <span class="text-muted">Ngày hoàn: </span>
                    <span>{{ dataOverviewInfor.refundCreatedTime | formatDate }}</span>
                  </p>
                  <p>
                    <span class="text-muted">Trạng thái: </span>
                    <b-badge
                      v-if="dataOverviewInfor.refundStatus"
                      :variant="mapVariantStatusRefund[dataOverviewInfor.refundStatus] ?? 'primary'"
                    >
                      {{
                        mapTextStatusRefund[dataOverviewInfor.refundStatus] ??
                        dataOverviewInfor.refundStatus
                      }}
                    </b-badge>
                  </p>
                  <p>
                    <span class="text-muted">Hoàn cọc: </span>
                    <span>{{ dataOverviewInfor.refundAmount | fomatCurrency }}</span>
                  </p>
                </div>
                <div v-else-if="dataOverviewInfor.additionalReceiptCode" class="card-body">
                  <p>
                    <span class="text-muted">Phiếu thu: </span>
                    <span>{{ dataOverviewInfor.additionalReceiptCode }}</span>
                  </p>
                  <p>
                    <span class="text-muted">Ngày thu: </span>
                    <span>{{ dataOverviewInfor.additionalReceiptCreatedTime | formatDate }}</span>
                  </p>
                  <p>
                    <span class="text-muted">Trạng thái: </span>
                    <b-badge
                      v-if="dataOverviewInfor.additionalReceiptStatus"
                      :variant="
                        mapVariantStatusReceipt[dataOverviewInfor.additionalReceiptStatus] ??
                        'primary'
                      "
                    >
                      {{
                        mapTextStatusReceipt[dataOverviewInfor.additionalReceiptStatus] ??
                        'Chưa thu tiền'
                      }}
                    </b-badge>
                  </p>
                  <p>
                    <span class="text-muted">Khấu hao: </span>
                    <span>{{ dataOverviewInfor.additionalCollectionAmount | fomatCurrency }}</span>
                  </p>
                </div>
                <div v-else class="card-body text-muted">
                  <p>Không có phiếu hoàn tiền / thu thêm</p>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row gap-4">
            <div class="col-lg-12">
              <div class="form-detail">
                <h1>Lịch sử thay đổi</h1>
                <div class="card-body">
                  <div class="table-responsive">
                    <b-table
                      :items="changeHistories"
                      :fields="changeHistoriesFields"
                      bordered
                      hover
                      responsive
                      stacked="md"
                      class="mb-0"
                    >
                      <template #cell(createdTime)="data">
                        {{ data.item.createdTime | formatDate('HH:mm DD/MM/YYYY') }}
                      </template>
                      <template #cell(creator)="data">
                        <div>
                          <p class="mb-1">{{ data.item?.creator?.name }}</p>
                          <p class="mb-0">{{ data.item?.creator?.email }}</p>
                        </div>
                      </template>
                      <template #cell(actionType)="data">
                        {{ mapTextActionType[data?.item?.actionType] }}
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalReCallOrExtend ref="modalRecallOrExtendRef" @change="fetchData" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import CardDetail from '@/components/CardDetail.vue'
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config'
  import { showMessError, showMessErrorResponse } from '@/config/utils'
  import ModalReCallOrExtend from './components/ModalReCallOrExtend.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'DetailLendingDevice',

    components: {
      CardDetail,
      ModalReCallOrExtend,
    },

    data() {
      return {
        Config,
        lendDeviceId: '',
        showLoading: false,
        changeHistories: [],
        dataOverviewInfor: {},
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      canAction() {
        const statusOk = ['WARNING'].includes(this.dataOverviewInfor.status)

        return {
          recall: statusOk && this.dataPermission.includes('CNPS_DEVICE_LENDING_ACTION_RECALL'),
          extend: statusOk && this.dataPermission.includes('CNPS_DEVICE_LENDING_ACTION_EXTEND'),
        }
      },
      mapTextStatusIDLend() {
        return Config.statusIDLend.reduce((acc, item) => {
          acc[item.id] = item.text
          return acc
        }, {})
      },
      mapVariantStatusIDLend() {
        return Config.statusIDLend.reduce((acc, item) => {
          acc[item.id] = item.variant
          return acc
        }, {})
      },
      mapTextReceiptStatus() {
        return Config.receiptStatus.reduce((acc, item) => {
          acc[item.id] = item.text
          return acc
        }, {})
      },
      mapVariantReceiptStatus() {
        return Config.receiptStatus.reduce((acc, item) => {
          acc[item.id] = item.variant
          return acc
        }, {})
      },
      mapTextStatusRefund() {
        return Config.statusRefund.reduce((acc, item) => {
          acc[item.id] = item.text
          return acc
        }, {})
      },
      mapVariantStatusRefund() {
        return Config.statusRefund.reduce((acc, item) => {
          acc[item.id] = item.variant
          return acc
        }, {})
      },
      mapTextStatusReceipt() {
        return Config.statusReceipts.reduce((acc, item) => {
          acc[item.id] = item.text
          return acc
        }, {})
      },
      mapVariantStatusReceipt() {
        return Config.statusReceipts.reduce((acc, item) => {
          acc[item.id] = item.variant
          return acc
        }, {})
      },
      mapTextActionType() {
        return Config.listActionType.reduce((acc, item) => {
          acc[item.id] = item.text
          return acc
        }, {})
      },
      generalFields() {
        const fields = [
          { label: 'ID cho mượn', value: this.dataOverviewInfor?.lendingId || '' },
          {
            label: 'Thông tin MC',
            value: this.dataOverviewInfor?.merchantName || '',
            key: 'inforMC',
          },
          { label: 'Tên thiết bị', value: this.dataOverviewInfor?.deviceCategoryName || '' },
          { label: 'Mã serial', value: this.dataOverviewInfor?.deviceSerial || '' },
          { label: 'Mã hợp đồng / phụ lục', value: this.dataOverviewInfor?.contractCode || '' },
          {
            label: 'Ngày bắt đầu mượn',
            value: this.dataOverviewInfor?.lendingStartTime || '',
            key: 'activeTime',
          },
          {
            label: 'Ngày hoạt động',
            value: this.dataOverviewInfor?.activeTime || '',
            key: 'activeTime',
          },
          {
            label: 'Tên kho',
            value: this.dataOverviewInfor?.inventoryName || '',
          },
          {
            label: 'Trạng thái',
            value: this.dataOverviewInfor?.status || '',
            key: 'status',
          },
          {
            label: 'Hóa đơn cho phần khấu hao',
            value: !!this.dataOverviewInfor?.invoiceExported || '',
            key: 'statusInvoiceExported',
          },
        ]
        return fields
      },
      receiptInfor() {
        const fields = [
          { label: 'Mã phiếu thu', value: this.dataOverviewInfor?.receiptCode || '' },
          {
            label: 'Ngày thu cọc',
            value: this.dataOverviewInfor?.receiptTime || '',
            key: 'receiptTime',
          },
          {
            label: 'Trạng thái',
            value: this.dataOverviewInfor?.receiptStatus || '',
            key: 'status',
          },
        ]
        return fields
      },
      refundInfor() {
        const fields = [
          { label: 'Mã phiếu hoàn tiền', value: this.dataOverviewInfor?.refundCode || '' },
          {
            label: 'Ngày hoàn cọc',
            value: this.dataOverviewInfor?.refundCreatedTime || '',
            key: 'refundStatus',
          },
          { label: 'Trạng thái', value: this.dataOverviewInfor?.refundStatus || '', key: 'status' },
          {
            label: 'Mã phiếu thu thêm',
            value: this.dataOverviewInfor?.additionalReceiptCode || '',
          },
          {
            label: 'Ngày thu thêm',
            value: this.dataOverviewInfor?.additionalReceiptCreatedTime || '',
            key: 'additionalReceiptTime',
          },
          {
            label: 'Trạng thái phiếu thu thêm',
            value: this.dataOverviewInfor?.additionalReceiptStatus || '',
            key: 'additionalStatus',
          },
        ]
        return fields
      },
      changeHistoriesFields() {
        return [
          { key: 'createdTime', label: 'Thời gian', thStyle: { minWidth: '120px' } },
          { key: 'creator', label: 'Người thực hiện' },
          { key: 'actionType', label: 'Loại hành động' },
          { key: 'notes', label: 'Ghi chú' },
        ]
      },
    },
    async created() {
      this.lendDeviceId = this.$route.params.id
    },
    async mounted() {
      await this.fetchData()
    },
    methods: {
      handleReqReceipt() {
        this.$refs.modalRecallOrExtendRef.openModal(
          this.dataOverviewInfor.id,
          this.dataOverviewInfor.lendingId,
          'recall'
        )
      },
      handleExtend() {
        this.$refs.modalRecallOrExtendRef.openModal(
          this.dataOverviewInfor.id,
          this.dataOverviewInfor.lendingId,
          'extend'
        )
      },
      async fetchData() {
        try {
          this.showLoading = true
          const response = await DeviceService.getDetailLendDeviceV1({ id: this.lendDeviceId })
          if (response.code === 1000) {
            const { histories, ...rest } = response.data
            this.dataOverviewInfor = rest
            console.log('histories', histories)
            this.changeHistories = histories || []
          } else {
            showMessError(this, response.message, 3000)
          }
        } catch (error) {
          showMessErrorResponse(this, error, 3000)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
